import { AxiosInstance } from "axios"
import { GenericResponse } from "."
import { UserModel } from "./user.api"

export interface GroupModel {
    id: number
    name: string
    desc: string
    //Permissions: []
    Menus?: any[]
    created_by: UserModel
    updated_by: UserModel
}

export interface CreateGroupRequest {
    name: string
    desc: string
    menus?: number[]
    mobileMenus?: number[]
}

export interface UpdateGroupRequest {
    id: number
    name?: string
    desc?: string
    menus?: number[]
    mobileMenus?: number[]
}

const groupApi = (apiInstance: AxiosInstance) => {
    const groupsList = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/groups/get-all-groups`)
        return res
    }

    const createGroup = async (newGroupData: CreateGroupRequest): Promise<GenericResponse> => {
        const { menus, mobileMenus } = newGroupData
        delete newGroupData["mobileMenus"]
        delete newGroupData["menus"]
        const res: Promise<GenericResponse> = apiInstance.post(`/groups/create-group`, {
            groupData: newGroupData,
            menus,
            mobileMenus
        })
        return res
    }

    const updateGroup = async (existingGroupData: UpdateGroupRequest): Promise<GenericResponse> => {
        const { menus, id, mobileMenus } = existingGroupData
        delete existingGroupData["mobileMenus"]
        delete existingGroupData["menus"]
        const res: Promise<GenericResponse> = apiInstance.put(`/groups/update-group`, {
            groupData: existingGroupData,
            menus,
            mobileMenus,
            groupId: id
        })
        return res
    }

    const validateGroupName = async (newGroupName: string): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/groups/validate-name`, {
            groupName: newGroupName
        })
        return res
    }

    const deleteGroup = async (groupId: number): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/groups/delete-unused-group`, { id: groupId })
        return res
    }

    return {
        groupsList,
        createGroup,
        updateGroup,
        validateGroupName,
        deleteGroup
    }
}

export default groupApi
